module.exports = __webpack_public_path__ + "static/branding-video-d748972a6a0bcfde74fd7488e8e5471d.gif";